import React, { Component } from 'react';
import './Header.css';

//Assets
import Logo from './Assets/logo/logodark';

//Helpers
import { Link } from 'react-router-dom';
import classnames from 'classnames';

export default class Header extends Component {

  render() {
    if (!this.props.company) {
      return (
        <header className={classnames('main-header')}>
            <div className="header-content wide-container">
              <Link className="logo" to="/"><Logo/></Link>
                <div className="header-links">
                </div>
            </div>
        </header>
      )
    }

    if (this.props.companyLogo) {
      const imageStyle = {
        backgroundImage: `url(${this.props.companyLogo})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }

      const companyURL = `/company/${this.props.companyID}`

      return (
        <header className={classnames('main-header')}>
            <div className="header-content wide-container">
              <Link to={companyURL}>
                <div className='header-logo-box'>
                  <div className="header-logo logo" style={imageStyle}></div>
                  <h5>{this.props.companyName || null}</h5>
                </div>
              </Link>
            </div>
        </header>
      )
    }

    return (
      <header className={classnames('main-header')}>
          <div className="header-content wide-container">
          <Link className="logo" to="/"><Logo/></Link>
          </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header.js